import { render, staticRenderFns } from "./chatAttributes.vue?vue&type=template&id=6ea72ee1&scoped=true&"
import script from "./chatAttributes.vue?vue&type=script&lang=js&"
export * from "./chatAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea72ee1",
  null
  
)

export default component.exports